import { Component } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

interface Message {
    sender: string;
    time: string;
    text: string;
}

@Component({
    selector: 'demo-upp-scrollable',
    templateUrl: './demo-upp-scrollable.html',
    styleUrls: ['../demo-common.scss', './demo-upp-scrollable.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppScrollableComponent {
    direction: 'none' | 'x' | 'y' | 'both' = 'y';

    messages: Message[] = [
        { sender: 'Alice', time: '09:01', text: 'Good morning! Ready for the standup?' },
        { sender: 'Bob', time: '09:02', text: 'Almost there, give me 2 minutes.' },
        { sender: 'Carol', time: '09:03', text: 'I pushed the fix for the login bug last night.' },
        { sender: 'Dave', time: '09:04', text: 'Great, I\'ll review it after the meeting.' },
        { sender: 'Alice', time: '09:05', text: 'Let\'s also discuss the new dashboard layout.' },
        { sender: 'Eve', time: '09:06', text: 'I have some mockups ready to share.' },
        { sender: 'Bob', time: '09:07', text: 'Perfect. Can you drop the link in the channel?' },
        { sender: 'Carol', time: '09:10', text: 'The API response times improved by 30% after the cache change.' },
        { sender: 'Dave', time: '09:12', text: 'Nice! We should document the caching strategy.' },
        { sender: 'Alice', time: '09:14', text: 'Agreed. I\'ll add it to the wiki this afternoon.' },
        { sender: 'Eve', time: '09:15', text: 'Also, the staging server needs a restart.' },
        { sender: 'Bob', time: '09:17', text: 'I\'ll handle that right after standup.' },
        { sender: 'Carol', time: '09:18', text: 'Don\'t forget to update the env variables.' },
        { sender: 'Dave', time: '09:20', text: 'Has anyone looked at the new feature request from the client?' },
        { sender: 'Alice', time: '09:22', text: 'Yes, it\'s basically a bulk import tool.' },
        { sender: 'Eve', time: '09:23', text: 'We could reuse the CSV parser from the reports module.' },
        { sender: 'Bob', time: '09:25', text: 'Good idea. Let me check if it supports custom delimiters.' },
        { sender: 'Carol', time: '09:27', text: 'It does. I added that last sprint.' },
        { sender: 'Dave', time: '09:30', text: 'Ok, let\'s wrap up. Everyone knows their tasks?' },
        { sender: 'Alice', time: '09:31', text: 'All clear. Talk later!' },
    ];

    constructor(private change: ChangeDetectorRef) {}

    setDirection(dir: 'none' | 'x' | 'y' | 'both') {
        this.direction = dir;
        this.change.markForCheck();
    }
}
